import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { useAnalytics } from "@/analytics";
import type { EstimateType } from "@/enums/estimate-type";

interface ArchiveProjectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
  estimateId: string;
  estimateType?: EstimateType;
}

export function ArchiveProjectDialog({ open, onOpenChange, onConfirm, isLoading, estimateId, estimateType }: ArchiveProjectDialogProps) {
  const { trackEvent, ANALYTICS_EVENTS } = useAnalytics();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="!bg-white text-black">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-medium text-gray-800">Archive this project?</AlertDialogTitle>
          <AlertDialogDescription className="mt-2 text-sm text-gray-600">
            This project will be archived and hidden from the dashboard.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-6 flex gap-2">
          <AlertDialogAction variant="destructive" disabled={isLoading} onClick={onConfirm}>
            {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
            Archive Project
          </AlertDialogAction>
          <AlertDialogCancel disabled={isLoading} onClick={() => trackEvent(ANALYTICS_EVENTS.PROJECT_ARCHIVE_CANCELLED, {
            estimate_id: estimateId,
            estimate_type: estimateType,
          })}>Cancel</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
